// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCheckOutlinedSvg from "@fishx/icons-svg/es/asn/PCheckOutlined";
import FishxIcon from '../components/FishxIcon';

var PCheckOutlined = function PCheckOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCheckOutlinedSvg
  }));
};

PCheckOutlined.displayName = 'PCheckOutlined';
export default React.forwardRef(PCheckOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCheckOutlined.js
// module id = 3282
// module chunks = 0